// The existing GTM-K2JH98K5 container loads this Google tag. Do not load or
// configure another tag here. Verified against the public container 2026-10-03.
export const GA4_DESTINATION = 'G-K7VZ640RSR';

export function trackGearEvent(name, parameters = {}) {
  const send = () => {
    try {
      window.dataLayer = window.dataLayer || [];
      // Google tag commands work even when GTM does not expose window.gtag.
      // Arguments objects are the documented gtag queue format; no manual
      // page_view and no duplicate object-event transport.
      function queue() { window.dataLayer.push(arguments); }
      queue('event', name, { ...parameters, send_to: GA4_DESTINATION });
    } catch {
      // Blocking analytics must never break navigation or category controls.
    }
  };
  // The GTM Google tag must configure its destination before receiving event
  // commands. Async tag scripts participate in the document load lifecycle.
  // Waiting for load avoids a race on fast cached HTML / slow tag downloads.
  if (document.readyState === 'complete') send();
  else {
    try { window.addEventListener('load', send, { once: true }); } catch { /* Unsupported/blocked environment. */ }
  }
}

const NAVIGATION_KEY = 'sfpdcalls:gear-navigation';

function navigationParameters(link) {
  return {
    direction: link.dataset.gearNavigation === 'gear' ? 'to_prod' : 'to_map',
    page_path: link.dataset.gearNavigation === 'gear' ? '/' : '/prod',
    destination_path: link.dataset.gearNavigation === 'gear' ? '/prod' : '/',
  };
}

function recordNavigation(event, link) {
  const parameters = navigationParameters(link);
  // A same-tab click can unload before GTM finishes loading. Hand off its
  // small, fixed record to the destination instead of delaying navigation.
  const sameTab = event.type === 'click' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
  if (sameTab) {
    try {
      window.sessionStorage.setItem(NAVIGATION_KEY, JSON.stringify({ ...parameters, created_at: Date.now() }));
      return;
    } catch { /* Restricted storage: use the ordinary event queue. */ }
  }
  trackGearEvent('prod_internal_navigation', { ...parameters, navigation_stage: 'activation' });
}

function consumeNavigation() {
  try {
    const record = JSON.parse(window.sessionStorage.getItem(NAVIGATION_KEY));
    window.sessionStorage.removeItem(NAVIGATION_KEY);
    if (!record) return;
    const validDirection = record.direction === 'to_prod' || record.direction === 'to_map';
    const destination = record.direction === 'to_prod' ? '/prod' : '/';
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    const age = Date.now() - record.created_at;
    if (!validDirection || record.destination_path !== destination || currentPath !== destination || !Number.isFinite(age) || age < 0 || age > 300000) return;
    trackGearEvent('prod_internal_navigation', {
      direction: record.direction,
      page_path: record.direction === 'to_prod' ? '/' : '/prod',
      destination_path: destination,
      navigation_stage: 'arrival',
    });
  } catch { /* No storage access must never stop page initialization. */ }
}

export function installGearNavigationTracking(root = document) {
  consumeNavigation();
  const handler = event => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest?.('a[data-gear-navigation]');
    if (link) recordNavigation(event, link);
  };
  root.addEventListener('click', handler);
  root.addEventListener('auxclick', handler);
}
